import CheckedBadgeIcon from './CheckedBadgeIcon';
import ExpertsBadgeTooltip from './ExpertsBadgeTooltip';
import InfoTooltip from '@/Components/Tooltip/InfoTooltip';
import UIStrings from '@/Utils/UIStrings';

function ExpertsBadge() {
    return (
        <div className="border-border flex flex-row items-center justify-center gap-2.5 rounded-full border px-2 py-1.5">
            <CheckedBadgeIcon />
            <span className="text-foreground text-center text-sm font-medium">
                {UIStrings.QualityTestsBuiltByIndustryExpertsValidatedByPsychologists}
            </span>
            <InfoTooltip description={<ExpertsBadgeTooltip />} />
        </div>
    );
}

export default ExpertsBadge;
